import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Fieldset } from 'primereact/fieldset'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import {
  Btn,
  CustomDataTableHeader,
  CustomDropdownWithFilter,
  CustomPanel,
  PageHeader,
  Periodo,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useAssociarPosicoes, { LOAD_MESSAGE } from './AssociarPosicoesHook'

function AssociarPosicoes({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useAssociarPosicoes()

  const { selectedInventario } = history.location.state

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_POSICOES:
        dispatch(showLoadingBox('Aguarde . . .', state.loadingMessage))
        localDispatch.getPosicoesToAssoc(
          selectedTp,
          selectedInventario.estoque_id,
          selectedInventario.inventario_id,
        )
        break

      case LOAD_MESSAGE.GET_PRODUTOS:
        dispatch(showLoadingBox('Aguarde . . .', state.loadingMessage))
        localDispatch.getProdutosFromCompany(selectedInventario.company_id)
        break

      case LOAD_MESSAGE.ASSOC_POS:
        dispatch(hideLoadingBox())
        localDispatch.assocPosicoesToInventario(
          selectedTp,
          selectedInventario.inventario_id,
          selectedInventario.estoque_id,
          state.selectedPosicoes,
        )
        break

      case LOAD_MESSAGE.ASSOC_POS_AUTO:
        dispatch(showLoadingBox('Aguarde . . .', state.loadingMessage))
        localDispatch.assocPosicoesToInventarioByProductMovement(
          selectedTp,
          selectedInventario.inventario_id,
          selectedInventario.estoque_id,
          state.selectedProduto,
          state.periodoAssociacaoAutomatica,
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  return (
    <div>
      <PageHeader>
        <span>
          8.9 - Inventario <b>{selectedInventario.inventory_name}</b> - Associar Posições
        </span>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => {}} showBtnNovo={false} onVoltar={history.goBack}>
          <React.Fragment>
            <div className="p-grid">
              <div className="p-col-12">
                <Fieldset
                  legend="Associação Automática"
                  toggleable
                  collapsed={state.associacaoAutomaticaCollapsed}
                  onToggle={e =>
                    localDispatch.onToggleAssociacaoAutomatica(
                      e.value,
                      selectedInventario.company_id,
                    )
                  }
                >
                  <div className="p-grid p-align-end">
                    <div className="p-col-12" style={{ marginTop: 10 }}>
                      <span>Inventário por produto: </span>
                    </div>
                    <div className="p-col-4">
                      <CustomDropdownWithFilter
                        filter={true}
                        filterMatchMode="contains"
                        placeholder="Selecione um Produto"
                        optionLabel={'produto'}
                        options={state.produtos}
                        label={'Produto'}
                        onChange={value => localDispatch.onChange('selectedProduto', value)}
                        value={state.selectedProduto}
                      />
                    </div>
                    <div className="p-col-3">
                      <Periodo
                        periodoInicial={state.periodoAssociacaoAutomatica.dataInicial}
                        periodoFinal={state.periodoAssociacaoAutomatica.dataFinal}
                        onChangePeriodoInicial={value =>
                          localDispatch.onPeriodoAssociacaoAutomaticaChange(
                            value,
                            state.periodoAssociacaoAutomatica.dataFinal,
                          )
                        }
                        onChangePeriodoFinal={value =>
                          localDispatch.onPeriodoAssociacaoAutomaticaChange(
                            state.periodoAssociacaoAutomatica.dataInicial,
                            value,
                          )
                        }
                        showButton={false}
                      />
                    </div>
                    <div className="p-col-fixed" style={{ paddingTop: 27 }}>
                      <Btn
                        onClick={() =>
                          localDispatch.onClickBuscarAssociar(
                            state.selectedProduto,
                            state.periodoAssociacaoAutomatica,
                          )
                        }
                      >
                        Buscar e Associar
                      </Btn>
                    </div>
                  </div>
                </Fieldset>
              </div>
              <div className="p-col-12">
                <div style={{ marginTop: 15 }}>
                  <DataTable
                    header={
                      <>
                        <div
                          className="p-grid p-justify-center"
                          style={{ marginTop: 10, marginBottom: 10 }}
                        >
                          <span style={{ display: 'inline-block' }}>
                            Estoque {selectedInventario.estoque}
                          </span>
                        </div>
                        <CustomDataTableHeader
                          onChange={value => localDispatch.onChange('globalFilter', value)}
                          value={state.globalFilter}
                          children={
                            <div style={{ display: 'inline-block', marginLeft: 25 }}>
                              <Btn
                                onClick={() =>
                                  localDispatch.onClickAssocPos(state.selectedPosicoes)
                                }
                              >
                                Associar
                              </Btn>
                            </div>
                          }
                        />
                      </>
                    }
                    globalFilter={state.globalFilter}
                    value={state.posicoes}
                    onSelectionChange={e => localDispatch.onChange('selectedPosicoes', e.value)}
                    selection={state.selectedPosicoes}
                    emptyMessage="Não existem posições para associação"
                    rows={10}
                    paginator={true}
                  >
                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                    <Column field="sequencia" header="Sequencia" style={tableCellCentered()} />
                    <Column field="endereco" header="Posição" />
                  </DataTable>
                </div>
              </div>
            </div>
          </React.Fragment>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AssociarPosicoes))
